/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';
import RadioOffIcon from 'app/components/icons/RadioOffIcon';
import RadioOnIcon from 'app/components/icons/RadioOnIcon';

type Props = {
  checked?: boolean,
  className?: string
};

const defaultProps = {
  checked: false,
  className: undefined
};

const Wrapper = styled.div(({ theme }) => ({
  height: '1.5em',
  position: 'relative',
  width: '1.5em',
  fontSize: theme.fontSize.default,
  display: 'flex',
  alignItems: 'center'
}));

const Inner = styled(RadioOnIcon)(({ theme }) => ({
  color: theme.color.primary,
  position: 'absolute',
  left: 0,
  top: 0
}));

const Outer = styled(RadioOffIcon)(({ color, theme }) => ({
  color: color || theme.color.panelAccent,
  position: 'absolute',
  left: 0,
  top: 0
}));

function RadioButton({ className, checked }: Props) {
  return (
    <Wrapper>
      {checked && <Inner />}
      <Outer className={className} />
    </Wrapper>
  );
}

RadioButton.defaultProps = defaultProps;

export default React.memo(RadioButton);
